import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Constant } from '../constant/constant';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI7 + "/api/ig/registration";


  url1 = environment.serverAPI + "/api/ig";

  createAccount(projects: any): Observable<Response[]> {


    let countryData = localStorage.getItem(Constant.COUNTRY_LOCATION);

    if (countryData != null || countryData != undefined) {

      let data = JSON.parse(countryData);

      let value = JSON.parse(projects.value);

      let finalValue = { ...value, ...data };

      projects.value = JSON.stringify(finalValue)


    }

    return this.http.post<Response[]>(`${this.url}`, projects);
  }

  resendOtp(projects: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/resend`, projects);
  }
  verifyOtp(projects: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/verify`, projects);
  }

  telephoneVerified(telephone: any): Observable<Object> {
    return this.http.get(`${this.url}/phoneNo/${telephone}`);
  }

  accountVerified(account: any): Observable<Object> {
    return this.http.get(`${this.url}/account/${account}`);
  }

  emailVerified(email: any): Observable<Object> {
    return this.http.get(`${this.url1}/customer/username/${email}`);
  }

  createAccountSocial(projects: any): Observable<Response[]> {


    let countryData = localStorage.getItem(Constant.COUNTRY_LOCATION);

    if (countryData != null || countryData != undefined) {

      let data = JSON.parse(countryData);

      let value = JSON.parse(projects.value);

      let finalValue = { ...value, ...data };

      projects.value = JSON.stringify(finalValue)


    }

    return this.http.post<Response[]>(`${this.url}/social`, projects);
  }



  getCountryCode() {
    return getConfig();
  }

}

function getConfig() {
  let config;

  function tryRequest(url: string): any | null {
    let req = new XMLHttpRequest();
    try {
      req.open('GET', url, false);
      req.setRequestHeader('Content-Type', 'application/json');
      req.send(null);
      if (req.status === 200) {
        return JSON.parse(req.responseText);
      }
    } catch (e) {
      console.error('getConfig: request failed for', url, e);
    }
    return null;
  }

  try {
    let obj = tryRequest('https://ipapi.co/json/');

    if (!obj) {
      // Fallback to ipinfo.io and normalize fields
      const fallback = tryRequest('https://ipinfo.io/json');
      if (fallback) {
        obj = {
          ip: fallback.ip,
          city: fallback.city,
          region: fallback.region,
          country: fallback.country,
          country_code: fallback.country,
          postal: fallback.postal,
          timezone: fallback.timezone,
          org: fallback.org
        };
      }
    }

    if (obj) {
      config = JSON.stringify(obj);
      localStorage.setItem(Constant.COUNTRY_LOCATION, JSON.stringify(obj));
    }
  } catch (e) {
    console.error('environment:getConfig: unable to get location: ', e);
  }

  return config;
}